import styles from "../style.module.scss";

export const Pill = ({ children }) => <div className={styles.eventPill}>{children}</div>;
